import React, { useContext } from 'react';
import { Route, Routes } from 'react-router';
import { Header, Tenant, Title, SubTitle } from '../../components/content/page-header';
import { General } from './general';
import { Capabilities } from './capabilities';
import { FieldConfiguration } from './field-configuration';
import { Theme } from './theme';
import { HazardTypes } from './hazard/hazard-types';
import { HazardSeverities } from './hazard/hazard-severities';
import { HazardCategories } from './hazard/hazard-categories';
import { ValueFormatters } from './value-formatters';
import { Extents } from './extents';
import { Palettes } from './palettes/palettes';
import { Protocols } from './protocols';
import { CoordinateSystems } from './coordinate-systems';
import { Sidebar, SidebarLink } from '../../components/layout/sidebar';
import { ContentWrapper } from '../../components/layout/content';
import { PaletteEditor } from './palettes/palette-editor';
import { SectionEditor } from './palettes/section-editor';
import { Placemarks } from './palettes/placemarks';
import { HazardTypeEditor } from './hazard/hazard-type-editor';
import authService from '../auth/auth-service';
import tenantService from '../../services/tenant-service';
import { Tenants } from './tenants';
import { TenantContext } from '../../state/tenant-state';

export const Settings = (): JSX.Element => {
  useContext(TenantContext);

  return <div>
    <Header>
      <Tenant />
      <Title>Settings</Title>
      <SubTitle>DisasterAWARE configuration settings.</SubTitle>
    </Header>
    <div>
      <Sidebar>
        <SidebarLink to="/settings">General</SidebarLink>
        <SidebarLink to="/settings/capabilities">Capabilities</SidebarLink>
        <SidebarLink to="/settings/field-configuration">Field Configuration</SidebarLink>
        <SidebarLink to="/settings/theme">Theme</SidebarLink>
        <SidebarLink to="/settings/hazard-types">Hazard Types</SidebarLink>
        <SidebarLink to="/settings/hazard-severities">Hazard Severities</SidebarLink>
        <SidebarLink to="/settings/hazard-categories">Hazard Categories</SidebarLink>
        <SidebarLink to="/settings/coordinate-systems">Coordinate Systems</SidebarLink>
        <SidebarLink to="/settings/protocols">Protocols</SidebarLink>
        <SidebarLink to="/settings/palettes">Palettes</SidebarLink>
        <SidebarLink to="/settings/extents">Extents</SidebarLink>
        <SidebarLink to="/settings/value-formatters">Value Formatters</SidebarLink>
        {authService.isSuperAdmin() && tenantService.isGoldMaster() && <SidebarLink to="/settings/tenants">Tenants</SidebarLink>}
      </Sidebar>
      <ContentWrapper>
        <Routes>
          <Route path="/" element={<General />} />
          <Route path="/capabilities" element={<Capabilities />} />
          <Route path="/field-configuration" element={<FieldConfiguration />} />
          <Route path="/theme" element={<Theme />} />
          <Route path="/hazard-types" element={<HazardTypes />} />
          <Route path="/hazard-types/:id" element={<HazardTypeEditor />} />
          <Route path="/hazard-severities" element={<HazardSeverities />} />
          <Route path="/hazard-categories" element={<HazardCategories />} />
          <Route path="/coordinate-systems" element={<CoordinateSystems />} />
          <Route path="/protocols" element={<Protocols />} />
          <Route path="/palettes" element={<Palettes />} />
          <Route path="/palettes/:paletteId" element={<PaletteEditor />} />
          <Route path="/palettes/:paletteId/sections/:sectionId" element={<SectionEditor />} />
          <Route path="/palettes/:paletteId/sections/:sectionId/placemarks" element={<Placemarks />} />
          <Route path="/palettes/placemarks" element={<Placemarks />} />
          <Route path="/extents" element={<Extents />} />
          <Route path="/value-formatters" element={<ValueFormatters />} />
          <Route path="/value-formatters/:id" element={<ValueFormatters />} />
          {authService.isSuperAdmin() && tenantService.isGoldMaster() && <Route path="/tenants" element={<Tenants />} />}
          <Route path="*" element={<div>Not Found</div>} />
        </Routes>
      </ContentWrapper>
    </div>
  </div>;
};
